// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jm-0";
export var discountCodeInput = "_jm-1";